import React from "react";
import { Route, Switch } from "react-router-dom";
import TaxApp from "../app/pages/tax";

const Tax = () => (
  <Switch>
    <Route path="/" component={TaxApp} />
  </Switch>
);

export default Tax;
